module.exports = __webpack_public_path__ + "img/img_product_03@2x.0e40cd0f.png";